import React, { useState, useEffect } from "react";
import { FaArrowCircleLeft, FaArrowCircleRight } from "react-icons/fa";
import { useSelector } from "react-redux";
import { Link } from 'react-router-dom';



const CategorySlider = ({ latestCategories,name }) => {
  const weburl=useSelector(state=>state.constants.weburl);
  //const [isHovered, setIsHovered] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [items, setItems] = useState([]);

  //const handleMouseEnter = () => setIsHovered(true);
  //const handleMouseLeave = () => setIsHovered(false);

  // Add extra items to the beginning and end for circular effect
  useEffect(() => {
    if (latestCategories.length > 6) {
      const extendedItems = [
        ...latestCategories.slice(-6), // Add last 6 items to the beginning
        ...latestCategories, // Original items
        ...latestCategories.slice(0, 6), // Add first 6 items to the end
      ];
      setItems(extendedItems);
      setCurrentIndex(6); // Start at the original first item
    } else {
      setItems(latestCategories); // No circular effect needed if <= 6 items
    }
  }, [latestCategories]);

  // Auto-slide functionality
  useEffect(() => {
    if (latestCategories.length > 6) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % latestCategories.length);
      }, 300000); // Change image every 3 seconds

      return () => clearInterval(interval); // Cleanup interval on unmount
    }
  }, [latestCategories.length]);

  // Go to the next image (move one item to the right)
  const goNext = () => {
    if (currentIndex + 1 < latestCategories.length) {
      setCurrentIndex((prevIndex) => prevIndex + 1); // Move right by one item
    } else {
      setCurrentIndex(0); // Wrap around to the first item
    }
  };

  // Go to the previous image (move one item to the left)
  const goPrev = () => {
    if (currentIndex - 1 >= 0) {
      setCurrentIndex((prevIndex) => prevIndex - 1); // Move left by one item
    } else {
      setCurrentIndex(latestCategories.length - 1); // Wrap around to the last item
    }
  };

 
  const showRightArrow = latestCategories.length > 6; // Show if more than 6 items

  const showLeftArrow = latestCategories.length > 6 && currentIndex > 0; // Show if slider has moved to the right
  return (
    <div className="w-full mx-2  mt-4 border-b border-gray-200" data-aos="fade-up">
    
    <div className="p-2 mb-4">
        <h1 className="text-2xl font-serif text-left p-2">
          <span className="p-2 rounded-sm font-bold">{name}</span>
        </h1>
      </div>
    <div className="relative overflow-hidden">
      {/* Slider Container */}
      <div
          className="flex transition-transform duration-500 ease-in-out w-[150%] sm:w-[200%] md:w-[120%] lg:w-[120%] xl:w-[100%]"
          style={{
            transform: `translateX(-${(currentIndex * (100 / 6))}%)`,
          }}
        >
        {items.map((item, index) => (
          <div
          key={index}
          className="w-1/1 sm:w-1/3 md:w-1/4 lg:w-1/6 flex-shrink-0 p-2" // Adjust width for mobile and larger screens
        >
            <Link to={`products/${item.id}`}>
              <div
                className="flex flex-col items-center justify-center"
               
              >
                <div className="overflow-hidden cursor-pointer h-40 w-40 rounded-full hover:translate-y-2 duration-700 flex shadow-md justify-center items-center myimg bg-slate-200">
                  <img
                    alt="img category"
                    className="p-2 object-cover object-right-top  w-full h-full rounded-full"
                    src={`${weburl}/${item.image}`}
                  />
                </div>
                <div className="text-black font-serif flex justify-center items-center">
                  <p>{item.name}</p>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>

      {/* Left Arrow (Conditional Rendering) */}
      {showLeftArrow && (
        <FaArrowCircleLeft
          className="absolute left-0 top-1/2 transform -translate-y-1/2 p-2 text-gray-400 rounded-full shadow-lg z-10 w-12 h-12"
          onClick={goPrev}
        />
      )}

      {/* Right Arrow (Conditional Rendering) */}
      {showRightArrow && (
        <FaArrowCircleRight
          onClick={goNext}
          className="absolute right-0 top-1/2 transform -translate-y-1/2 p-2 text-gray-400 bg-white rounded-full shadow-lg w-12 h-12 z-10"
        />
      )}
    </div> </div>
  );
};

export default CategorySlider;